import React from 'react';
import * as styles from './IE11Screen.module.scss';
import logo from '../assets/images/built-logo.svg';
import { Button } from '@built/design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const IE11Screen = (): React.ReactElement => {
  console.warn(
    'You are using an unsupported browser - please contact your CSM for a list of all supported browsers'
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <img src={logo} alt="Built Logo" />
      </div>
      <div className={styles.contentWrap}>
        <div className={'EmptyState'}>
          <h4 className={'EmptyState-label'}>Browser not supported</h4>
          <p className={'EmptyState-message'}>
            We recommend using Built with one of the following browsers:
          </p>
        </div>

        <div className={styles.buttonRow}>
          <Button
            href={'https://www.google.com/chrome/'}
            className={styles.buttonOverride}
            icon={<FontAwesomeIcon icon={'chrome'} />}
            buttonType={'secondary'}
            data-testid="google-chrome-button"
          >
            {`${'Google Chrome'}`}
          </Button>
          <Button
            href={'https://www.mozilla.org/en-US/firefox/new/'}
            className={styles.buttonOverride}
            icon={<FontAwesomeIcon icon={'firefox-browser'} />}
            buttonType={'secondary'}
            data-testid="firefox-button"
          >
            {`${'Mozilla Firefox'}`}
          </Button>
          <Button
            href={'https://www.microsoft.com/en-us/edge'}
            className={styles.buttonOverride}
            icon={<FontAwesomeIcon icon={'edge'} />}
            buttonType={'secondary'}
            data-testid="edge-button"
          >
            {`${'Microsoft Edge'}`}
          </Button>
        </div>
        <hr />
        <div className={styles.copyWrap}>
          <p>
            {`${"Support for Internet Explorer was removed as of September 17th, 2021 to coincide with Microsoft's ending of support for 365 apps. The links to the above browsers are what Built supports. Depending on your organization, you may need to work with your IT Department to acquire a supported browser. Need help? Contact support@getbuilt.com"}`}
          </p>
        </div>
      </div>
    </div>
  );
};
